
/**
 * 用于控制新颖性检查功能的服务
 */
export interface FtoReportNoveltyFeatureControlService {
    /**
     * 是否允许添加专利
     */
    isPatentAdditionEnabled: boolean;
    /**
     * 是否允许查看专利详情
     */
    isPatentDetailViewEnabled: boolean;
    /**
     * 是否允许编辑对比文献
     */
    isComparativeLiteratureEditEnabled: boolean;
    /**
     * 是否允许提供反馈
     */
    isFeedbackEnabled: boolean;
    /**
     * 是否允许导出报告
     */
    isExportEnabled: boolean;
}

export const FtoReportNoveltyFeatureControlService = Symbol.for('FtoReportNoveltyFeatureControlService');
